import { AttachmentContentProps } from '../AttachmentContent';
import { CodeContentProps } from '../CodeContent';
import { DateContentProps } from '../DateContent';
import { ImageContentProps } from '../ImageContent';
import { LongTextContentProps } from '../LongTextContent';
import { MultiSelectContentProps } from '../MultiSelectContent';
import { SingleSelectContentProps } from '../SingleSelectContent';
import { TextContentProps } from '../TextContent';


type CellInternalProps = {
  attachmentContent?: AttachmentContentProps;
  dateContent?: DateContentProps;
  imageContent?: ImageContentProps;
  codeContent?: CodeContentProps;
  longTextContent?: LongTextContentProps;
  multiSelectContent?: MultiSelectContentProps;
  textContent?: TextContentProps;
  singleSelectContent?: SingleSelectContentProps;
};

type CellPropsValues = {
  'Attachment': CellInternalProps;
  'Date': CellInternalProps;
  'Image': CellInternalProps;
  'JSON': CellInternalProps;
  'LongText': CellInternalProps;
  'MultiReference': CellInternalProps;
  'MultiSelect': CellInternalProps;
  'Number': CellInternalProps;
  'ShortText': CellInternalProps;
  'SingleReference': CellInternalProps;
  'SingleSelect': CellInternalProps;
};

const propValues: CellPropsValues = {
  'Attachment': {
    attachmentContent: {
      state: 'Default',
    },
  },
  'Date': {
    dateContent: {
      state: 'Default',
    },
  },
  'Image': {
    imageContent: {
      state: 'Default',
    },
  },
  'JSON': {
    codeContent: {
      state: 'Default',
    },
  },
  'LongText': {
    longTextContent: {
      state: 'Default',
    },
  },
  'MultiReference': {
    multiSelectContent: {
      state: 'Default',
    },
  },
  'MultiSelect': {
    multiSelectContent: {
      state: 'Default',
    },
  },
  'Number': {
    textContent: {
      state: 'Default',
    },
  },
  'ShortText': {
    textContent: {
      state: 'Default',
    },
  },
  'SingleReference': {
    singleSelectContent: {
      state: 'Default',
    },
  },
  'SingleSelect': {
    singleSelectContent: {
      state: 'Default',
    },
  },
};

const getProps = (type: string): CellInternalProps => {
  const values: CellInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
